module.exports = "/assets/landing-dw/instagram/instagram.png?qW4/g4m";